import styled from '@emotion/styled';
import React from 'react';
import type { InputProps } from '../Input';
import { Input } from '../Input';

const Host = styled.div``;

export function EmailInput({ ...rest }: InputProps) {
  return (
    <Host>
      <Input {...rest} />
    </Host>
  );
}
